import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Switch,
  Box,
  Typography,
  SxProps,
  Theme,
} from "@mui/material";

interface SwitchWithDescriptionProps {
  name: string;
  label: string;
  description: string;
  disabled?: boolean;
  sx?: SxProps<Theme>;
  formik: {
    setFieldValue: (
      field: string,
      value: unknown,
      shouldValidate?: boolean
    ) => void;
    setFieldTouched: (
      field: string,
      isTouched?: boolean,
      shouldValidate?: boolean
    ) => void;
    values: Record<string, unknown>;
    touched: Record<string, boolean>;
    errors: Record<string, string>;
  };
}

const SwitchWithDescription = ({
  name,
  label,
  description,
  disabled = false,
  sx = {},
  formik,
}: SwitchWithDescriptionProps) => {
  const { setFieldValue, setFieldTouched, values, touched, errors } = formik;
  const error = touched[name] && errors[name];

  return (
    <FormControl
      error={Boolean(error)}
      sx={{ maxWidth: "100%", alignItems: "flex-start", width: "100%", ...sx }}
    >
      <FormControlLabel
        labelPlacement="start"
        control={
          <Switch
            checked={Boolean(values[name])}
            onChange={(_, checked) => setFieldValue(name, checked)}
            onBlur={() => setFieldTouched(name, true)}
            disabled={disabled}
            name={name}
          />
        }
        label={
          <Box>
            <Typography sx={{ fontWeight: 600 }}>{label}</Typography>
            <Typography
              variant="caption"
              sx={{
                fontSize: "0.8rem",
                color: "text.secondary",
              }}
            >
              {description}
            </Typography>
          </Box>
        }
        sx={{
          m: 0,
          width: "100%",
          justifyContent: "space-between",
        }}
      />
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default SwitchWithDescription;
